// src/utils/postMessage.js

/**
 * Send message to parent window (dashboard)
 * @param {string} action - The action type (e.g., 'ACTIVATE_FEATURE', 'NAVIGATE_TO')
 * @param {Object} data - Additional data to send with the message
 */
export const sendMessageToParent = (action, data = {}) => {
    const message = {
      type: 'IN_APP_LANDING_PAGE_ACTION',
      action: action,
      data: data,
      timestamp: Date.now(),
      source: 'in_app_landing_page'
    };
    
    try {
      window.parent.postMessage(message, '*');
      
      // For production, change origin to 'dashboard.instant.one':
      // window.parent.postMessage(message, 'https://dashboard.instant.one');
      
      console.log('Message sent to parent:', message);
    } catch (error) {
      console.error('Error sending message to parent:', error);
    }
  };
  
  /**
   * Example action types
   */
  export const ACTIONS = {
    ACTIVATE_FEATURE: 'ACTIVATE_FEATURE',
    NAVIGATE_TO: 'NAVIGATE_TO',
  };